export default "__VITE_ASSET__ebc82533__"